import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less']
})
export class ButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
